// Use the existing gallery player after an explicit user action.
if (!window.p004ProductVideoInstalled) {
  window.p004ProductVideoInstalled = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-p004-video-target]');
    if (!link) return;
    const posterId = link.dataset.p004VideoTarget;
    const poster = document.getElementById(posterId);
    if (!poster) return;
    const deferred = poster.closest('deferred-media');
    if (!deferred) return;
    event.preventDefault();
    const gallery = deferred.closest('media-gallery');
    const mediaItem = deferred.closest('[data-media-id]');
    if (gallery && mediaItem && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(mediaItem.dataset.mediaId, false);
    }
    deferred.scrollIntoView({ behavior: 'instant', block: 'center' });
    const player = deferred.querySelector('video');
    if (player) {
      player.focus({ preventScroll: true });
      player.play()?.catch(() => {});
    } else {
      poster.click();
    }
  });
}
